import tokens from '@nike/design-system-base';
var black = tokens.color('black');
var lightBlack = tokens.color('black', 'light');
var nikeOrange = tokens.color('orange');
var nikeOrangeDark = tokens.color('orange', 'light');
var white = tokens.color('white');
var offWhite = tokens.brand('primaryGrey');
// const grey = tokens.color('grey');
var darkGrey = tokens.color('grey', 'dark');
// const lightGrey = tokens.brand('borderGrey');
// const green = tokens.color('green');
// const red = tokens.color('red');

// NOTE - we need to start aligning with the lingo that design systems is using, ie primary-text
var colors = {
  text: {
    primary: 'var(--podium-cds-color-text-primary)',
    light: 'var(--podium-cds-color-text-secondary)',
    xlight: 'var(--podium-cds-color-border-tertiary)',
    dark: 'var(--podium-cds-color-text-primary)',
    contrast: 'var(--podium-cds-color-text-primary-inverse)',
    accent: 'var(--podium-cds-color-brand-orange)',
    success: 'var(--podium-cds-color-text-success)',
    error: 'var(--podium-cds-color-text-critical)',
    disabled: 'var(--podium-cds-color-text-disabled)'
  },
  link: {
    primary: 'var(--podium-cds-color-text-secondary)',
    secondary: 'var(--podium-cds-color-text-secondary)',
    accent: 'var(--podium-cds-color-brand-orange)'
  },
  background: {
    primary: white,
    secondary: {
      normal: nikeOrange,
      dark: nikeOrangeDark
    },
    tertiary: offWhite,
    contrast: darkGrey,
    dark: black,
    darkFade: lightBlack
  },
  // NOTE - Podium values are assigned to maintain current design. Element markup will need to be adjusted so the Podium values align properly.
  // For example, --podium-cds-color-border-tertiary assigned to the border.primary. Markup on our border elements needs to change so primary values can be aligned.
  border: {
    primary: 'var(--podium-cds-color-border-tertiary)',
    dark: 'var(--podium-cds-color-border-active)',
    error: 'var(--podium-cds-color-border-critical)',
    bordercolor: 'var(--podium-cds-button-color-border-secondary-inverse)'
  }
};
colors.promos = {
  applied: colors.text.success,
  ineligible: colors.text.light
};
export default colors;